export default {
  general: {
    search: 'Szukaj',
    edit: 'Edytuj',
    confirm: 'Potwierdź',
    remove: 'Usuń',
    cancel: 'Anuluj',
    save: 'Zapisz',
    finish: 'Zakończ',
    name: 'Nazwa',
    add: 'Dodaj',
    ok: 'OK',
    details: 'Szczegóły',
    packOs: 'PackOS',
    config: 'ConfigHub',
    workboost: 'WorkBoost',
    keepup: 'KeepUp',
    goodin: 'GoodIn',
    goodinQa: 'GoodIn QA',
    bucketService: 'Bucket Service',
    knowlake: 'KnowLake',
    logicprint5: 'LogicPrint5',
    logicprint7: 'LogicPrint7',
    results: 'wyników',
    noPermissions: 'Brak uprawnień',
    plant: 'Fabryka',
    description: 'Opis',
    code: 'Kod',
    to: 'Do',
    from: 'Od',
    copiedToClipboard: 'Skopiowano do schowka',
    now: 'Teraz',
    noData: 'Brak danych',
    default: 'Domyślna',
    clone: 'Klonuj',
    general: 'Generalna',
    iWantToProceed: 'Chcę kontynuować',
    requestReceived: 'Żądanie otrzymane',
    of: 'z',
  },
  menu: {
    userSettings: 'Ustawienia konta',
    logout: 'Wyloguj',
  },
  plants: {
    name: 'Nazwa',
    code: 'Kod',
    latitude: 'Szerokość geograficzna',
    longitude: 'Długość geograficzna',
    structure: 'Struktura fabryki',
    selectPlant: 'Wybierz fabrykę',
  },
  diy: {
    setupStatuses: 'Status konfiguracji fabryki',
    database: 'Baza danych',
    appService: 'App service',
    deployment: 'Deployment',
    apiPlantsInfoUpdate: 'Dodanie informacji o nowej fabryce w API',
    enforceSetupDoneStatus: 'Zmień status konfiguracji na pomyślny',
    setupErrorMessage: 'Konfiguracja nie powiodła się. Skontaktuj się z działem supportu.',
  },
  elements: {
    area: 'Obszar',
    line: 'Linia',
    machine: 'Maszyna',
    type: 'Typ elementu',
    location: 'Lokalizacja',
    addElement: 'Dodaj linię/maszynę/obszar',
    capabilities: 'Obsługa',
    capability: {
      activities: 'Aktywności',
      downtimes: 'Przestoje',
      production: 'Produkcja',
      oee: 'OEE',
    },
  },
  auth: {
    signOut: 'Wyloguj',
  },
  pages: {
    plants: 'Fabryki',
    people: 'Ludzie',
    classifications: 'Klasyfikacje',
    products: 'Produkty',
    licenses: 'Licencje',
    settings: 'Ustawienia',
    myAccount: 'Moje konto',
    auditLog: 'Logi audytowe',
  },
  people: {
    users: 'Użytkownicy',
    roles: 'Role',
    competences: 'Kompetencje',
    noPermission: 'Brak uprawnień do zarządzania użytkownikami',
  },
  users: {
    add: 'Dodaj użytkownika',
    all: 'Wszyscy użytkownicy',
    import: 'Importuj użytkowników',
    userName: 'Login',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    name: 'Nazwa użytkownika',
    displayName: 'Nazwa',
    email: 'E-mail',
    phone: 'Telefon',
    companyEmployeeId: 'Firmowe ID pracownika',
    new: 'Nowy użytkownik',
    roles: 'Role',
    elementAccess: 'Dostęp do',
  },
  settings: {
    card: 'Karta',
    blockCard: 'Zablokuj kartę',
    pinChange: 'Zmień PIN',
    cardId: 'Numer karty',
    cardPin: 'PIN karty',
    oldCardPin: 'Aktualny PIN',
    newCardPin: 'Nowy PIN',
    activeSince: 'Aktywna od',
    inactiveSince: 'Nieaktywna od',
    pinLengthError: 'PIN musi mieć 4 cyfry',
    cardIdLengthError: 'Numer karty jest za krótki. Wymagana długość:',
    help: 'Pomoc',
  },
  account: {
    password: 'Hasło',
    roles: 'Role',
    passwordsNotEqual: 'Oba hasła muszą być jednakowe',
    repeatPassword: 'Powtórz hasło',
    newPassword: 'Nowe hasło',
    oldPassword: 'Aktualne hasło',
    claims: 'Uprawnienia',
    edit: 'Edycja konta',
    usersEdition: 'Edycja użytkowników',
    selfEditWarning: 'Nie możesz edytować swoich własnych uprawnień do fabryk',
    permissions: 'Uprawnienia',
    settings: 'Moje konto',
  },
  error: {
    unknown: 'Nieznany błąd',
    incorrectEmail: 'Adres e-mail powinien być w formacie example@domain.com',
    emptyInput: 'To pole nie może być puste',
    wrongInput: 'Podane dane są nieprawidłowe!',
    passwordsMustBeEqual: 'Hasła muszą być identyczne!',
    incorrectCoordinate: 'Współrzędna powinna być podana w formacie 12.34567',
    incorrectCode: 'Kod może zawierać tylko litery i cyfry oraz nie może być dłuższy niż 256 znaków',
    importNotAvailable: 'Import nie jest aktualnie możliwy. Spróbuj ponownie później.',
    jobFailed: 'Wystąpił błąd w trakcie przetwarzania pliku',
    listOfErrors: 'Lista błędów',
    tooLongString: 'Wartość pola jest zbyt długa',
    userNameTooLong: 'Login jest zbyt długi (limit 450 znaków)',
  },
  competence: {
    add: 'Dodaj kompetencje',
    expiryDate: 'Data wygaśnięcia',
  },
  role: {
    add: 'Dodaj rolę',
    manager: 'Kierownik',
    new: 'Nowy rolę',
    chooseRole: 'Wybierz rolę',
  },
  permissions: {
    inheritedFrom: 'Dziedziczone z ',
    add: 'Dodaj uprawnienia',
    systemAdmin: 'Administrator systemu',
    releaseNotesAccess: 'Opis zmian',
    choosePermission: 'Wybierz uprawnienie',
    chooseTenant: 'Wybierz Tenanta',
    chooseGroup: 'Wybierz Grupę',
    choosePlant: 'Wybierz fabrykę',
    chooseAsset: 'Wybierz zasób',
    assignedTargets: 'Przypisane',
    unassign: 'Odepnij',
    configure: 'Konfiguruj',
    tenantAdminAccess: 'Administrator organizacji',
    tenantAuditLogAccess: 'Dostęp do logów audytowych organizacji',
    plantAuditLogAccess: 'Dostęp do logów audytowych fabryki',
    plantElementAccess: 'Dostęp do elementu fabryki',
    worklogRerun: 'Ponowne przetwarzanie danych linii',
    plantAccess: 'Dostęp do fabryki',
    changeDowntimes: 'Zmiana przestojów',
    elementAccess: 'Dostęp do elementu',
    projectCreateAccess: 'Możliwość tworzenia projektów',
    usersManagementAccess: 'Dostęp do zarządzania użytkownikami',
    projectAdminAccess: 'Administrator projektu',
    projectAccess: 'Dostęp do projektu',
    taskAdminAccess: 'Dostęp do zarządzania zadaniami',
    taskStatusAccess: 'Dostęp do akceptowania zadań',
    orderManagementAccess: 'Dostęp do zarządzania zleceniami produkcyjnymi',
    orderOperationAccess: 'Dostęp do uruchamiania zleceń produkcyjnych',
    plantAdminAccess: 'Administrator fabryki',
    writeAccess: 'Dostęp do edycji elementu i jego zleceń',
    readAccess: 'Dostęp do przeglądania elementu i jego zleceń',
    orderManagement: 'Zarządzanie zleceniami',
    orderCreate: 'Tworzenie zleceń',
    orderViewAccess: 'Dostęp do wyświetlenia zleceń',
    orderCompleteManualProduction: 'Dostęp do manualnej produkcji w zakończonych zleceniach',
    orderCompleteEdit: 'Dostęp do edycji zakończonego zlecenia',
    orderInprogressEdit: 'Dostęp do edycji trwającego zlecenia',
    orderLifecycle: 'Obsługa cyklu życia zlecenia',
    orderEdit: 'Edycja zlecenia',
    orderWithdraw: 'Wycofanie zwolnionego/aktywowanego zlecenia',
    materialManagement: 'Zarządzanie Master Material',
    showSkuList: 'Wyświetlanie listy SKU',
    editSkuList: 'Edytowanie grup SKU',
    statesManagement: 'Edycja stanów maszyn i reguł',
    statesEdit: 'Edycja stanów',
    addReason: 'Dodawanie przyczyny',
    addCorrectiveAction: 'Dodawanie akcji korekcyjnej',
    editProblems: 'Edycja problemów',
    reportAccess: 'Dostęp do raportów',
    targetConfig: 'Dostęp do edycji oczekiwanej wydajności i energii',
    importer: 'Korzystanie z importera danych do wgrywania aktywności lub przedmiotów',
    customReportManagement: 'Zarządzanie współdzielonymi raportami',
    functionsConfig: 'Konfiguracja funkcji przetwarzania wstępnego',
    hintsConfig: 'Konfiguracja reguł podpowiedzi',
    importTemplatesManagement: 'Zarządzanie szablonami importu',
    activityTypesManagement: 'Zarządzanie typami aktywności',
    plantConfig: 'Konfiguracja fabryki',
    configFlow: 'Edycja struktury lini i połączeń',
    elementsOrder: 'Edycja kolejności wyświetlania elementów',
    unitsEdit: 'Edycja słownika jednostek',
    configShifts: 'Edycja słownika i harmonogramu zmian',
    dayStart: 'Edycja początku dnia pracy',
    configSignals: 'Edycja sygnałów i właściowści',
    notificationEdit: 'Edycja notyfikacji',
    serviceDefinitionManagement: 'Zarządzanie definicjami serwisu',
    projectCreate: 'Tworzenie projektów',
    projectAdmin: 'Zarządzanie projektem',
    projectView: 'Wyświetlanie zadań w projekcie',
    templatesManagement: 'Zarządzanie szablonami zadań i grup zadań',
    questsCreate: 'Tworzenie zadań',
    questGroupAdmin: 'Zarządzanie zadaniami w obrębie grupy użytkowników',
    groupQuests: 'Wyświetlanie zadań przypisanych do grupy',
    manualDowntime: 'Dodawanie przestojów',
    manualProduction: 'Potwierdzanie aktualnej produkcji',
    manageDowntimes: 'Zarządzanie przestojami',
    updateSuccessfully: 'Aktualizacja uprawnień zakończona sukcesem.',
    labelling: 'Etykietowanie',
    serializationAndAggregation: 'Serializacja i agregacja',
    orders: 'Zlecenia',
    sku: 'SKU',
    labels: 'Etykiety',
    requests: 'Żądania',
    settings: 'Ustawienia',
    planning: 'Planowanie',
    production: 'Produkcja',
    archive: 'Archiwum',
    importLog: 'Logi importowe',
    tenantLicenseAccess: 'Dostęp do licencji tenantów',
    cockpitManagement: 'Zarządzanie kokpitem',
    cockpitView: 'Podgląd kokpitu',
    cockpitOperations: 'Operacje kokpitu',
    cockpitRestrictions: 'Ograniczenia kokpitu',
    ordersManagement: 'Zarządzanie zleceniami',
    ordersView: 'Podgląd zleceń',
    ordersLifecycle: 'Cykl życia zlecenia',
    ordersCreate: 'Tworzenie zleceń',
    ordersEdit: 'Edycja zleceń',
    skuManagement: 'Zarządzanie SKU',
    skuView: 'Podgląd SKU',
    skuEdit: 'Edycja SKU',
    skuRestrictions: 'Ograniczenia SKU',
    palletsManagement: 'Zarządzanie paletami',
    palletsView: 'Podgląd palet',
    palletsLifecycle: 'Cykl życia palet',
    goodInQAWebQualitySamples: 'Raport próbek jakościowych',
    goodInQAWebPallets: 'Raport palet',
    goodInQAMobileQualitySamples: 'Moduł "JAKOŚĆ" na skanerze',
    goodInQAMobilePallets: 'Moduł "MAGAZYN" na skanerze',
    bucketServiceWebReworksReport: 'Raporty REWORK',
    bucketServiceWebMixCockpit: 'Kokpit MIX',
    bucketServiceWebMixArchive: 'Archiwum MIX',
    bucketServiceMobileReworks: 'Moduł "REWORK" na skanerze',
    newExperience: 'Nowy widok',
    classicView: 'Widok klasyczny',
    searchPermissions: 'Szukaj uprawnień',
    selectPermissionToPreview: 'Wybierz uprawnienie, aby je skonfigurować',
    inheritedTooltip: 'Nadawane automatycznie razem z uprawnieniem nadrzędnym',
    includedLabel: 'Uwzględnione',
    grantsLowerLevelPermissionsDisclaimer:
    'Nadanie tego uprawnienia automatycznie nada również wszystkie uprawnienia niższego poziomu wymienione poniżej.',
    showIncludedPermissions: 'Pokaż uwzględnione uprawnienia',
    includedPermissionsModalTitle: 'Uwzględnione uprawnienia',
    plantAdminAccessDescription:
      'Pełny dostęp administracyjny do fabryki, obejmujący wszystkie uprawnienia konfiguracyjne i zarządcze.',
    plantElementAccessDescription: 'Podgląd elementów fabryki (linii, maszyn) i przeglądanie ich danych.',
    manageDowntimesDescription: 'Zarządzanie przyczynami przestojów i powiązanymi ustawieniami elementu fabryki.',
    manualDowntimeDescription: 'Ręczne rejestrowanie przestoju na elemencie fabryki.',
    changeDowntimesDescription: 'Edycja lub przeklasyfikowanie już zarejestrowanych przestojów.',
    orderManagementDescription: 'Zarządzanie zleceniami produkcyjnymi na elemencie fabryki.',
    orderCreateDescription: 'Tworzenie nowych zleceń produkcyjnych.',
    orderViewAccessDescription: 'Podgląd zleceń produkcyjnych i ich szczegółów.',
    orderCompleteManualProductionDescription: 'Rejestrowanie manualnej produkcji na zleceniach już zakończonych.',
    orderInprogressEditDescription: 'Edycja zleceń będących w trakcie realizacji.',
    orderCompleteEditDescription: 'Edycja zleceń, które zostały już zakończone.',
    orderLifecycleDescription: 'Zarządzanie pełnym cyklem życia zlecenia: zwolnienie, aktywacja i zakończenie.',
    orderEditDescription: 'Edycja szczegółów zlecenia, np. ilości lub SKU.',
    manualProductionDescription: 'Rejestrowanie manualnych ilości produkcji na zleceniu.',
    orderWithdrawDescription: 'Wycofanie zwolnionego lub już aktywowanego zlecenia.',
    materialManagementDescription: 'Zarządzanie danymi Master Material dla fabryki.',
    showSkuListDescription: 'Podgląd listy SKU.',
    editSkuListDescription: 'Tworzenie, edycja i organizacja grup SKU.',
    statesManagementDescription: 'Zarządzanie stanami maszyn i powiązanymi z nimi regułami.',
    statesEditDescription: 'Edycja definicji stanów maszyn i reguł.',
    addReasonDescription: 'Dodawanie nowych przyczyn przestojów.',
    addCorrectiveActionDescription: 'Dodawanie nowych akcji korygujących dla problemów.',
    editProblemsDescription: 'Edycja definicji problemów i ich klasyfikacji.',
    reportAccessDescription: 'Dostęp do raportów dla fabryki lub modułu.',
    configFlowDescription: 'Edycja struktury linii i połączeń między elementami.',
    elementsOrderDescription: 'Zmiana kolejności wyświetlania elementów fabryki.',
    unitsEditDescription: 'Edycja słownika jednostek.',
    configShiftsDescription: 'Edycja harmonogramu i słownika zmian.',
    configSignalsDescription: 'Konfiguracja sygnałów wejścia/wyjścia dla fabryki.',
    targetConfigDescription: 'Edycja oczekiwanych celów wydajności i zużycia energii.',
    importerDescription:
      'Wgrywanie aktywności lub przedmiotów do fabryki przez importer danych, z użyciem skonfigurowanych szablonów.',
    customReportManagementDescription: 'Zarządzanie współdzielonymi raportami niestandardowymi w organizacji.',
    functionsConfigDescription: 'Konfiguracja funkcji przetwarzania wstępnego używanych w przepływach danych.',
    hintsConfigDescription: 'Konfiguracja reguł podpowiedzi wyświetlanych operatorom.',
    importTemplatesManagementDescription: 'Zarządzanie szablonami używanymi przez importer danych.',
    activityTypesManagementDescription: 'Konfiguracja typów, podtypów i dodatkowych pól aktywności w zakładzie.',
    worklogRerunDescription: 'Ponowne uruchomienie przetwarzania danych linii dla wcześniejszych worklogów.',
    tenantAdminAccessDescription: 'Pełny dostęp administracyjny do organizacji i jej konfiguracji.',
    usersManagementAccessDescription: 'Zarządzanie użytkownikami organizacji, ich rolami i uprawnieniami.',
    notificationEditDescription: 'Edycja ustawień powiadomień dla użytkowników.',
    plantConfigDescription: 'Konfiguracja ustawień i struktury fabryki.',
    tenantLicenseAccessDescription: 'Podgląd podsumowania licencji organizacji.',
    writeAccessDescription: 'Modyfikacja elementu KeepUp i jego zleceń roboczych.',
    readAccessDescription: 'Podgląd elementu KeepUp i jego zleceń roboczych.',
    plantAccessDescription: 'Dostęp do fabryki w KeepUp.',
    projectCreateDescription: 'Tworzenie nowych projektów WorkBoost.',
    projectAdminDescription: 'Administrowanie projektem WorkBoost i jego ustawieniami.',
    projectViewDescription: 'Podgląd projektu WorkBoost i jego zawartości.',
    templatesManagementDescription: 'Zarządzanie szablonami zadań w WorkBoost.',
    questsCreateDescription: 'Tworzenie nowych zadań w projekcie WorkBoost.',
    questGroupAdminDescription: 'Administrowanie grupą zadań WorkBoost.',
    groupQuestsDescription: 'Podgląd zadań w grupie zadań WorkBoost.',
    labellingDescription: 'Dostęp do funkcji etykietowania w LogicPrint5.',
    serializationAndAggregationDescription: 'Dostęp do funkcji serializacji i agregacji w LogicPrint5.',
    ordersDescription: 'Zarządzanie zleceniami w LogicPrint5.',
    skuDescription: 'Zarządzanie SKU w LogicPrint5.',
    labelsDescription: 'Zarządzanie szablonami etykiet w LogicPrint5.',
    requestsDescription: 'Zarządzanie żądaniami w LogicPrint5.',
    settingsDescription: 'Konfiguracja ustawień modułu.',
    cockpitManagementDescription: 'Zarządzanie kokpitem LogicPrint7.',
    cockpitViewDescription: 'Podgląd kokpitu LogicPrint7.',
    cockpitOperationsDescription: 'Wykonywanie operacji z poziomu kokpitu LogicPrint7.',
    cockpitRestrictionsDescription: 'Konfiguracja ograniczeń dla kokpitu LogicPrint7.',
    ordersManagementDescription: 'Zarządzanie zleceniami w LogicPrint7.',
    ordersViewDescription: 'Podgląd zleceń w LogicPrint7.',
    ordersLifecycleDescription: 'Zarządzanie cyklem życia zleceń w LogicPrint7.',
    ordersEditDescription: 'Edycja zleceń w LogicPrint7.',
    ordersCreateDescription: 'Tworzenie nowych zleceń w LogicPrint7.',
    skuManagementDescription: 'Zarządzanie SKU w LogicPrint7.',
    skuViewDescription: 'Podgląd SKU w LogicPrint7.',
    skuEditDescription: 'Edycja SKU w LogicPrint7.',
    skuRestrictionsDescription: 'Konfiguracja ograniczeń SKU w LogicPrint7.',
    palletsManagementDescription: 'Zarządzanie paletami w LogicPrint7.',
    palletsViewDescription: 'Podgląd palet w LogicPrint7.',
    palletsLifecycleDescription: 'Zarządzanie cyklem życia palet w LogicPrint7.',
    planningDescription: 'Dostęp do funkcji planowania w GoodIn.',
    productionDescription: 'Dostęp do funkcji produkcyjnych w GoodIn.',
    archiveDescription: 'Dostęp do archiwum GoodIn.',
    importLogDescription: 'Podgląd dziennika importu GoodIn.',
    goodInQAWebQualitySamplesDescription: 'Dostęp do raportu próbek jakościowych w GoodIn QA.',
    goodInQAWebPalletsDescription: 'Dostęp do raportu palet w GoodIn QA.',
    goodInQAMobileQualitySamplesDescription: 'Dostęp do modułu "QUALITY" na skanerze GoodIn QA.',
    goodInQAMobilePalletsDescription: 'Dostęp do modułu "WAREHOUSE" na skanerze GoodIn QA.',
    bucketServiceWebReworksReportDescription: 'Dostęp do raportów REWORK w Bucket Service.',
    bucketServiceWebMixCockpitDescription: 'Dostęp do kokpitu MIX w Bucket Service.',
    bucketServiceWebMixArchiveDescription: 'Dostęp do archiwum MIX w Bucket Service.',
    bucketServiceMobileReworksDescription: 'Dostęp do modułu "REWORK" na skanerze Bucket Service.',
  },
  registration: {
    register: 'Zarejestruj',
    companyName: 'Nazwa firmy',
    companyDescription: 'Opis firmy',
    nextStep: 'Następny krok',
    companySetUp: 'Założ swoją firmę',
    profileSetUp: 'Załóż swój profil',
    create: 'Utwórz',
    successful: 'Twoja firma i profil zostały pomyślnie utworzone',
    getStarted: 'Rozpocznij',
    passwordValidation: 'Hasło powinno zawierać przynajmniej 6 znaków i dwie cyfry',
    products: 'Wybierz produkt',
    invalidEmail: 'Nieprawidłowy adres email',
    regulations: 'Akceptuję regulamin',
    tryAgain: 'Spróbuj ponownie',
    addressUrl: 'Adres Url',
  },
  keepUp: {
    workBoostIntegration: 'Integracja z WorkBoost',
    useWorkBoost: 'Używaj WorkBoosta',
    project: 'Projekt',
    type: 'Typ',
    initialState: 'Stan początkowy',
  },
  notify: {
    nothing: 'Brak powiadomień',
  },
  auditLogs: {
    tenant: 'Tenant',
    version: 'Wersja',
    timestamp: 'Data',
    type: 'Typ zdarzenia',
    event: 'Zdarzenie',
    dateRange: 'Kiedy',
    aggregateId: 'Id agregatu',
    userId: 'Id użytkownika',
    userName: 'Użytkownik',
  },
  table: {
    paginationPrevText: 'Poprzedni',
    paginationNextText: 'Następny',
  },
  licenses: {
    tenantLicenses: 'Licencje tenantów',
    machineLicenses: 'Licencje maszyn',
    line: 'Linia',
    baseAutomated: 'Maszyny Base Automated',
    advancedAutomated: 'Roszerzenia Advanced Signals',
    entryManual: 'Maszyny Manualne',
    entryDummy: 'Maszyny Dummy',
    signal: 'Rozszerzenia o 20 Sygnałów',
    vision: 'Rozszerzenia Vision',
    aggregate: 'Razem w fabryce',
    timestamp: 'Licencje maszyn na',
    year: 'Rok',
  },
  import: {
    upload: 'Upuść pliki tutaj żeby wysłać',
    notSaved: 'Nie zapisano',
    saved: 'Zapisano',
    actionRequired: 'Zweryfikuj',
    checked: 'Zweryfikowano',
    fillAndAdd: 'Wypełnij i dodaj',
    nothingImported: 'Brak poprawnych danych do importu',
    previousImports: 'Poprzednie importy',
    fileIsBeingProcessed: 'Plik jest przetwarzany',
  },
  taxonomies: {
    unableToFetch: 'Konfiguracja klasyfikacji niedostępna',
    taxonomy: 'Taksonomie',
    classification: 'Klasyfikacja',
    classifications: 'Klasyfikacje',
    defaultClassification: 'Domyślna klasyfikacja',
    defaultTaxonomy: 'Domyślna taksonomia',
    assignTo: 'Przypisz do',
    pickANode: 'Wybierz węzeł',
    nodeDisabledForSelection: 'Nie można przypisać do tego węzła',
    continueToAddNodes: 'Kontynuuj, aby dodać węzły',
    createNewClassification: 'Stwórz nową klasyfikacje',
    factoryStructure: 'Struktura fabryki',
    problems: 'Problemy',
    classificationFor: 'Klasyfikacja dla',
    whereToCloneClassification: 'Dokąd chcesz sklonować tę klasyfikację?',
    areYouSureAboutEdit: 'Czy na pewno chcesz edytować tę sekcję?',
    thisCanProblemsInElements: 'Może to powodować problemy powiązań z poziomami w sekcji węzłów.',
    doYouWantToRemoveThisClassification: 'Czy chcesz usunąć tę klasyfikację?',
    enterName: 'Podaj nazwę',
    enterDescription: 'Podaj opis',
    enterCode: 'Podaj kod',
    level: 'Poziom',
    levels: 'Poziomy',
    pickLevel: 'Wybierz poziom',
    nodeWarning: 'Musisz wybrać poziom dla węzła. Sprawdź czy ten węzeł może znajdować się pod tym poziomem',
    editLevels: 'Edytuj poziomy',
    addLevel: 'Dodaj poziom',
    nodes: 'Węzły',
    editNodes: 'Edytuj węzły',
    addNode: 'Dodaj węzeł',
    addLevelToStartEditing: 'Dodaj poziom, aby rozpocząć edycję',
    addNodeToStartEditing: 'Dodaj węzeł, aby rozpocząć edycję',
    levelLockedTooltip: 'Jeśli poziom jest zablokowany, nie można przypisać żadnych problemów ani elementów '
      + 'do węzłów w tym poziomie.',
  },
};
